import {Component, OnInit, OnDestroy } from '@angular/core';
import {Subscription } from 'rxjs/Subscription';
import {Observable } from 'rxjs/Observable';

import * as _ from 'lodash';

import { SocketService, EComando } from '../../_services/socket.service';
import { PeerService } from '../../_services/peer.service';
import { UsuarioService } from '../../_services/usuario.service';
import { EUsuarioRol } from '../../../common/usuario';
import { Peer } from '../../../common/peer';
import { IPeerMonitor, ETipoPeer } from '../../../common/monitor'

@Component({
    selector: 'consola-ext',
    template: `
    <div class="row">
        <div class="col-sm-3">

            <div class="panel panel-primary">
                <div class="panel-heading"><i class="fa fa-globe"></i> Troncales</div>
                <ul class="list-group" style="margin-bottom: 0">
                    <li style="padding: 10px; border-bottom: 0" class="list-group-item" *ngFor="let t of (troncales$ | async)">
                        <troncal [troncal]="t"></troncal>
                    </li>
                </ul>
            </div>

        </div>
        <div class="col-sm-9">

            <ul class="nav nav-tabs" role="tablist" style="font-size: 13px">
                <li role="presentation" class="active">
                    <a href="javascript:void(0)">
                        <strong><i class="fa fa-headphones"></i> Extensiones</strong>
                    </a>
                </li>
                <li role="presentation" *ngIf="$usuario.usuario.permisos === _rol.ADMIN">
                    <a href="javascript:void(0)" (click)="nuevaExt()">
                        <i class="fa fa-plus-circle"></i> Crear Extensión
                    </a>
                </li>
            </ul>
            <div class="tab-content" style="margin-top: 10px">
                <div class="col-md-2 col-sm-3 col-xs-6 text-center" style="margin-bottom: 10px; padding: 5px" *ngFor="let e of peers">
                    <extension [exten]="e" (editar)="editarExt($event)" [mod]="$usuario.usuario.permisos === _rol.ADMIN"></extension>
                </div>
            </div>
            
        </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="modalEditPeer">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h5 class="modal-title"><strong><i class="fa fa-phone"></i> Edición de extension {{peerEdicion?.usuario}}</strong></h5>
            </div>
            <div class="modal-body">
                <peer-tag [peer]="peerEdicion" [readOnly]="readOnly" (peer)="actualizarPeer($event)"></peer-tag>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    `
})
export class ConsolaComponent implements OnInit, OnDestroy {
    
    private readOnly: boolean;
    private peerEdicion: IPeerMonitor;
    private peersSubs: Subscription;
    private troncales$: Observable<IPeerMonitor[]>;
    private _rol = EUsuarioRol;
    
    private peers: IPeerMonitor[] = [];
    
    constructor(private $monitor: SocketService, private $peer: PeerService, private $usuario: UsuarioService) {
        this.peersSubs = this.$monitor.getPeers()
            //<editor-fold defaultstate="collapsed" desc="peersMap">
            .map(peers => _.filter(peers, ["tipo", ETipoPeer[ETipoPeer.PEER]]))
            
            // Buscar si los peers aun estan en this.peers sino borrarlos
            .map(peers => {
                let i = this.peers.length;
                while (i--) {
                    if (_.findIndex(peers, ['usuario', this.peers[i].usuario]) === -1) // no existe
                        this.peers.splice(i, 1);
                }
                return peers;
            })
            .flatMap(peers => Observable.from(peers))
            .map(peer =>  {
                //<editor-fold defaultstate="collapsed" desc="Merge de canales con peers">
                let channel = _.find(this.$monitor.getChannels(), c => {
                    return (c.Channel.indexOf("/" + peer.usuario +"-") > -1)
                });
                // Si existe un canal que apunte a esta extensión
                if (!!channel) {
                    peer.estado = channel.Stats;
                    // let time = new Date(channel.Duration * 1000);
                    // time.setHours(time.getHours() - 19);
                    let time = new Date('2017-01-01 00:00:00');
                    time = new Date(time.getTime() + channel.Duration * 1000)

                    if (channel.Application === "AppDial") {
                        // Llamada entrante
                        peer.extra = {
                            tiempo: time.getTime(),
                            canal:  "Entrante",
                            app:    channel.Application
                        }
                    } else {
                        peer.extra = {
                            tiempo: time.getTime(),
                            canal:  "O: " + channel.Exten,
                            app:    channel.Application
                        }
                    }
                }
                //</editor-fold>

                // Setear estados
                if (peer.estado.indexOf("OK") > -1 || peer.estado.indexOf('LAGGED') > -1)
                    peer.estado_class = 'btn-success';
                else if (peer.estado.indexOf('Up') > -1 || peer.estado.indexOf('Ring') > -1)
                    peer.estado_class = 'btn-danger';
                else
                    peer.estado_class = 'btn-default';
                return peer;
            })
            .subscribe(
                peer => {
                    let index = _.findIndex(this.peers, ['usuario', peer.usuario]);

                    if (index < 0) { // No existe
                        this.peers.push(peer);
                        this.peers = _.cloneDeep(_.sortBy(this.peers, 'usuario'))
                    }
                    
                    // Comparar si los valores del objeto han cambiado
                    else if (JSON.stringify(peer) !== JSON.stringify(this.peers[index])) 
                        this.peers[index] = peer;
                    
                },
                err => console.warn(err)
            );
            //</editor-fold>

        this.troncales$ = this.$monitor.getPeers()
            //<editor-fold defaultstate="collapsed" desc="troncalesMap">
            .map(peers => _.filter(peers, ["tipo", ETipoPeer[ETipoPeer.TRUNK]]))
            .map(peers => {
                peers.forEach(peer =>  {
                    peer.channels = _.filter(this.$monitor.getChannels(), c => {
                        return (c.Channel.indexOf("/" + peer.usuario +"-") > -1)
                    });
                    
                    if (peer.estado.indexOf("OK") > -1 || peer.estado.indexOf('LAGGED') > -1)
                        peer.estado_class = 'btn-success';
                        
                    else if (peer.estado.indexOf("BUSY") > -1) // Solo en canales dahdi
                        peer.estado_class = 'btn-danger';
                        
                    else if (peer.estado.indexOf("RESERVED") > -1)  // Solo en canales dahdi
                        peer.estado_class = 'none';
                        
                    else
                        peer.estado_class = 'btn-default';
                });
                return peers;
            });
            //</editor-fold>
    }
    
    ngOnInit() { }
    
    ngOnDestroy(){
        this.peersSubs.unsubscribe()
    }
    
    nuevaExt() {
        this.readOnly = false;
        this.peerEdicion = <IPeerMonitor>{};
        $('#modalEditPeer').modal()
    }
    
    editarExt(peer: IPeerMonitor) {
        this.readOnly = true;
        this.peerEdicion = peer;
        $('#modalEditPeer').modal()
    }
    
    actualizarPeer(data: { peer: Peer, update: boolean}) {
        this.$peer.updatePeer(data)
            .map(() => data.peer.protocolo)
            .flatMap(protocolo => this.$monitor.enviarComando({
                comando: EComando.KERBERUS_FILE,
                data: { tipo: protocolo + "_CONF"}
            }))
            .flatMap(() => this.$monitor.enviarComando({
                comando: EComando.KERBERUS_FILE,
                data: { tipo: "EXTEN_EXTRA"}
            }))
            .subscribe(res => {
                console.log(res);
                $('#modalEditPeer').modal('hide')
            })
    }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/consola_ext/consola.component.ts